import {Model} from 'pinia-orm';

export default class CampaignPackage extends Model {

    static get entity () {
        return 'campaign_packages';
    }

    static fields () {
        return {
            id: this.uid(),
            type_id: this.attr(null),
            img_src: this.attr(null),
            price: this.attr(0.00),
            list_price: this.attr(0.00),
            order: this.attr(0),
            translations: this.attr(null),
        }
    }

    static fetch(country) {
        return axios.get(route('api.manage.companies.campaign-packages.index'), {
            params: {country}}).then(res => res.data);
    }

    static createCampaign(data) {
        return axios.post(route('api.manage.companies.campaign-packages.request'), data)
            .then(res => res.data);
    }
}
